<section class="page-wrap animated fadeIn">

  <header class="pattern-header">
    Corn Maze
  </header>

  <div class="corn mb-5">

    <div class="landing-container">

      <div class="row">
        <div class="col-12">
          <p class="h6-regular text-center">
            At Carlton Farms we design and cut our own maze. <strong>Our corn maze is a 5-acre field with approximately
              2
              miles of
              trails</strong>. We cut our design in the maze with lots of dead ends and wrong turns for you to navigate.
            It usually
            <strong>takes maze goers 30 minutes to an hour to navigate the maze</strong>. It is perfect for all ages! We
            hope to see your
            family, church groups, business and friends at this year's maze!
          </p>
          <p class="h6-regular text-center">
            The corn maze and hayride are stroller & handicap accessible.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="py-3 col-12 col-md-6 col-lg-6 animated fadeInDown">
          <div class="card-activity">
            <img class="icon" src="/assets/images/landing/farm-activities/corn-maze/dates.webp" alt="Calendar icon" />
            <div>
              <span class="h6-bold">
                Dates
              </span>
              <div class="h6-regular">
                <p>
                  To be announced for the 2025 season.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="py-3 col-12 col-md-6 col-lg-6 animated fadeInDown">
          <div class="card-activity">
            <img class="icon" src="/assets/images/landing/farm-activities/corn-maze/hours.webp" alt="Clock icon" />
            <div>
              <span class="h6-bold">
                Hours
              </span>
              <div class="h6-regular">
                <ul class="m-0">
                  <li>Friday: 6pm - 9pm</li>
                  <li>Saturday: 11am - 9pm</li>
                  <li>Sunday: 12 noon - 7pm</li>
                </ul>
                <small class="h8-regular">
                  *Remember to bring a flashlight if you plan to navigate the maze after dark.
                </small>
              </div>
            </div>
          </div>
        </div>
        <div class="py-3 col-12 col-md-6 col-lg-6 animated fadeInDown">
          <div class="card-activity">
            <img class="icon" src="/assets/images/landing/farm-activities/corn-maze/activities.webp"
              alt="Runner icon" />
            <div>
              <span class="h6-bold">
                Activities
              </span>
              <div class="h6-regular">
                <ul class="m-0">
                  <li>Corn Maze</li>
                  <li>Pumpkin Patch</li>
                  <li>Farm Tour</li>
                  <li>Hay Ride</li>
                  <li>Baby Animal Barn</li>
                  <li>Kiddie Play Area</li>
                  <li>Corn Cannon (extra fees apply- $1 for 3 shots)</li>
                  <li>Concession Stand</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="py-3 col-12 col-md-6 col-lg-6 animated fadeInDown">
          <div class="card-activity">
            <img class="icon" src="/assets/images/landing/farm-activities/corn-maze/admission.webp" alt="Ticket icon" />
            <div>
              <span class="h6-bold">
                Admission
              </span>
              <div class="h6-regular">
                <ul class="m-0">
                  <li>Ages 2 & under: no charge</li>
                  <li>Ages 3-12: $ 12</li>
                  <li>Ages 13-64: $ 15</li>
                  <li>Ages 65 and over, Military & First Responders: $ 2 discount</li>
                  <li>Cash or Credit Card only -we do not accept checks-(3.8% charge for credit cards)</li>
                </ul>
                <small class="h8-regular">
                  *All activities included in admissions price, except Corn Cannon.
                </small>
              </div>
            </div>
          </div>
        </div>
        <div class="py-3 col-12 col-md-12 col-lg-12 animated fadeInDown">
          <div class="card-activity">
            <img class="icon" src="/assets/images/landing/farm-activities/corn-maze/rules.webp" alt="Document icon" />
            <div>
              <span class="h6-bold">
                Rules
              </span>
              <div class="h6-regular">
                <p>
                  Corn Maze rules are posted at the entrance if you do not follow the rules you will be asked to leave.
                  No
                  refunds.
                </p>
                <span>
                  <strong>General Rules</strong>
                </span>
                <ul class="m-0">
                  <li>
                    NO ALCOHOL
                  </li>
                  <li>
                    Smoking is not permitted.
                  </li>
                  <li>
                    No pets are allowed other than service animals.
                  </li>
                  <li>
                    Adults and parents, you are responsible for the children you bring with you. Please stay with your
                    children.
                  </li>
                  <li>
                    No alcohol, drugs, or persons under the influence of either are allowed.
                  </li>
                  <li>
                    WE HAVE A STRICT NO DROP-OFF POLICY! ALL CHILDREN 12 AND UNDER MUST BE ACCOMPANIED BY AN ADULT INTO
                    THE CORN MAZES. WE CANNOT BE RESPONSIBLE FOR UNSUPERVISED CHILDREN. ADULTS NEED TO PLAN ON DOING THE
                    CORN MAZE ALONG WITH THEIR CHILDREN.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <h2 class="h2-semibold my-4">
          Gallery
        </h2>

        <div class="gallery">
          @for (item of gallery(); track $index) {
          <img class="gallery__img" [class.cover]="!item.fill" [class.fill]="item.fill"
            src="/assets/images/landing/farm-activities/corn-maze/{{item.name}}" alt="{{item.alt}}">
          }
        </div>
      </div>

    </div>

  </div>
</section>